import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Accordion from "@limitless/modern/surfaces/accordion/Accordion";
import Button from "@limitless/modern/inputs/button/Button";
import { useKnowledgeLibraryContext } from "../..";
import { RemoteContent } from "../..";
import NoArticle from "../../components/knowledge-base/NoArticle";
const KnowledgeArticleList = () => {
  const [copied, setCopied] = React.useState(false);
  const [plainText, setPlainText] = React.useState("");
  const [selectedArticleIndex, setSelectedArticleIndex] = React.useState(null);
  const articleEl = React.useRef(null);
  const {
    selectedArticle,
    updateSelectedArticle,
    libraryResults
  } = useKnowledgeLibraryContext();
  const {
    hasSearched,
    faqs,
    searchResults
  } = libraryResults;
  React.useEffect(() => {
    loadCopyText();
    setCopied(false);
  }, [selectedArticle]);
  React.useEffect(() => {
    setSelectedArticleIndex(null);
  }, [faqs, searchResults]);
  const loadCopyText = () => {
    if (document.getElementById("kb-article")) {
      setPlainText(document.getElementById("kb-article").innerHTML);
    }
  };
  const handleArticleClick = (article, index) => {
    updateSelectedArticle({
      ...article,
      selectedArticleIndex: index
    });
  };
  const articleList = hasSearched ? searchResults : faqs;
  if (articleList.length === 0 && hasSearched) {
    return /*#__PURE__*/React.createElement(NoArticle, null);
  }
  return articleList === null || articleList === void 0 ? void 0 : articleList.map((faq, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Accordion, {
      title: faq.question,
      expanded: !selectedArticle.loading && selectedArticleIndex === index,
      onChange: (e, isExpanded) => {
        setSelectedArticleIndex(isExpanded ? index : null);
        handleArticleClick(faq, index);
      },
      showDivider: articleList.length > 1 && articleList.length !== index + 1,
      loading: selectedArticle.loading && selectedArticleIndex === index
    }, /*#__PURE__*/React.createElement(RemoteContent, {
      content: selectedArticle.answer,
      ref: articleEl,
      id: "kb-article"
    }), /*#__PURE__*/React.createElement(Grid, {
      mt: 2.5,
      mb: 3
    }, /*#__PURE__*/React.createElement(CopyToClipboard, {
      text: plainText,
      onCopy: () => setCopied(true)
    }, /*#__PURE__*/React.createElement(Button, {
      id: "copyAnswerButton",
      variant: "contained",
      size: "small"
    }, copied ? "Copied" : "Copy")))));
  });
};
export default KnowledgeArticleList;